import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QRTemplatesState } from './qr-templates.reducer';

export const selectQRTemplatesState = createFeatureSelector<QRTemplatesState>('qrTemplates');

export const selectQRTemplates = createSelector(selectQRTemplatesState, (state) => state.qrTemplates);
export const selectQRTemplatesMeta = createSelector(selectQRTemplatesState, (state) => state.meta);
export const selectQRTemplatesLoading = createSelector(selectQRTemplatesState, (state) => state.isLoading);
export const selectQRTemplatesError = createSelector(selectQRTemplatesState, (state) => state.error);
export const selectQRTemplatesLastLoadParams = createSelector(
  selectQRTemplatesState,
  (state) => state.lastLoadParams
);

// Selectors for drawer
export const selectCurrentQRTemplate = createSelector(selectQRTemplatesState, (state) => state.currentTemplate);
export const selectQRTemplateSaving = createSelector(selectQRTemplatesState, (state) => state.isSaving);
export const selectQRTemplateDeleting = createSelector(selectQRTemplatesState, (state) => state.isDeleting);
